import React from 'react';
import * as rdr from 'react-date-range';
import { es } from 'date-fns/locale';
import { Button } from 'react-bootstrap';
import { addDays } from 'date-fns';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';

function getTodayLocalMidnight() {
    const now = new Date();
    return new Date(now.getFullYear(), now.getMonth(), now.getDate());
}

function getEndOfWeekFrom(date) {
    const d = new Date(date);
    const day = d.getDay();
    const daysUntilSunday = (7 - day) % 7;
    d.setDate(d.getDate() + daysUntilSunday);
    d.setHours(0, 0, 0, 0);
    return d;
}

function TacticDueDateRangePicker({
    range,
    handleDateChange,
    onSelectNoDueDate,
    setIsDatePickerOpen,
}) {
    const today = getTodayLocalMidnight();
    const tomorrow = addDays(today, 1);
    const endOfWeek = getEndOfWeekFrom(today);

    const quickRanges = [
        {
            label: 'Vence Hoy',
            onClick: () =>
                handleDateChange({
                    selection: { ...range[0], startDate: today, endDate: today, key: 'selection' },
                }),
        },
        {
            label: 'Vence mañana',
            onClick: () =>
                handleDateChange({
                    selection: { ...range[0], startDate: tomorrow, endDate: tomorrow, key: 'selection' },
                }),
        },
        {
            label: 'Vence esta semana',
            onClick: () =>
                handleDateChange({
                    selection: { ...range[0], startDate: today, endDate: endOfWeek, key: 'selection' },
                }),
        },
        {
            label: 'Sin fecha de vencimiento',
            onClick: () => onSelectNoDueDate(),
        },
    ];

    const handleQuickRangeClick = (action) => {
        action();
        setIsDatePickerOpen(false);
    };

    return (
        <div style={{ display: 'flex', maxWidth: '100%' }}>
            <div className="d-flex flex-column p-2 bg-light border-end" style={{ width: '220px' }}>
                <h6 className="text-muted ms-2 mt-1 mb-2">Rangos Rápidos</h6>
                {quickRanges.map((quickRange) => (
                    <Button
                        key={quickRange.label}
                        type="button"
                        variant="light"
                        className="text-start mb-1"
                        onClick={() => handleQuickRangeClick(quickRange.onClick)}
                    >
                        {quickRange.label}
                    </Button>
                ))}
            </div>
            <div>
                <rdr.DateRange
                    locale={es}
                    months={1}
                    direction="horizontal"
                    showSelectionPreview
                    moveRangeOnFirstSelection={false}
                    ranges={range}
                    onChange={handleDateChange}
                    staticRanges={[]}
                    inputRanges={[]}
                />
            </div>
        </div>
    );
}

export default TacticDueDateRangePicker;
